export const aboutData = {
    title: "Who I am",
    description1: "I'm Gangatharan and Hardware & Netwok Engineer from Musiri,Tamilnadu.",
    description2: "My journey is fueled by an insatiable thirst for knowledge and a passion for exploring new territories. Whether it's mastering the latest in network security protocols, delving into the intricacies of server architecture, I am constantly expanding the breadth of my expertise. .",
     image: 1
}